<template>
  <div class="app-container">
    <div class="flex h-30 align-center">
      <div class="bg-ff flex flex-1 h-30 align-center plr-10 border-ra">
        <div class="flex font-16-f5971d font-bold"><span class="bg-4-f5971d"></span>成功案例客户</div>
      </div>
      <div class="flex ml-10">
        <div class="flex  align-center ">
          <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="储备开始时间"
            value-format="yyyy-MM-dd">
          </el-date-picker>
          <span class="font-12-b9b9b9" style="width: 24px;border: 1px solid #e2e2e2;height: 30px; line-height: 30px;">至</span>
          <el-date-picker
            v-model="endTime"
            type="date"
            @on-judge="judge"
            placeholder="储备结束时间"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input class=" font-12-85" type="text" placeholder="楼盘小区" v-model="inputValue" clearable @keyup.enter.native="searchBtn"></el-input>
          </div>
          <button class="btn-30-bg-82b925" @click="searchBtn">搜索</button>
        </div>
      </div>
    </div>
    <div class="mtb-10 flex">
    </div>
    <div class="flex-1">
      <erp-table ref="erpTable" :table-data="tableData"  :loading="loading" @on-detail="onDetail" :column-data="columnData"></erp-table>
    </div>
    <div style="margin-top: 10px;">
      <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
    </div>
  </div>
</template>

<script>
import ErpTable from '@/components/ErpTable'
import Pagination from '@/components/Pagination'
let isActivated = false // 判断是使用缓存数据还是加载新数据
export default {
  name: 'successfulCases',
  components: {ErpTable, Pagination},
  data () {
    return {
      startTime: '',
      endTime: '',
      inputValue: '',
      page: 1,
      limit: 20,
      pageSize: 10, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 10, // 当前页条数
      total: 100, // 总条数
      loading: true,
      columnData: [{
        type: 'selection',
        width: '40',
        fixed: 'left'
      }, {
        field: 'operate',
        title: '操作',
        width: '70',
        fixed: 'left',
        isDefine: true,
        child: [{
          className: 'btn-16-bd-85 btn-hover',
          title: '打开',
          methodName: 'on-detail',
          type: 'btn'
        }]
      }, {
        type: 'index',
        title: '序号',
        width: '60',
        fixed: 'left'
      }, {
        field: 'businessStatus',
        title: '业务状态',
        width: '120'
      }, {
        field: 'residentialDistrict',
        title: '楼盘小区',
        minWidth: '250'
      }, {
        field: 'decorationStyle',
        title: '装修风格',
        minWidth: '120'
      }, {
        field: 'homeType',
        title: '户型',
        minWidth: '120'
      }, {
        field: 'buildingArea',
        title: '建筑面积',
        width: '80'
      }, {
        field: 'customerAssign.designerName',
        title: '设计师',
        width: '100'
      }, {
        field: 'customerAssign.pmName',
        title: '项目经理',
        width: '140'
      }],
      tableData: []
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.meta) {
      /**
       * isActivated: true --> 后退而来
       * isActivated：false --> 其他页面跳转来
       */
      isActivated = from.meta.isActivated || false
    }
    next()
  },
  created () {},
  mounted () {
  },
  activated () {
    if (!isActivated) {
      /**
       * 若为从其他平行页面跳转过来时，不需要缓存，则加载数据并进行其他初始化操作
       */
      this.keywords = null
      this.customerManageStartTime = null
      this.customerManageEndTime = null
      this.loading = true
      // 其他操作
    }
    this.getData()
  },
  methods: {
    getData () {
      let that = this
      if (!that.startTime) {
        that.startTime = ''
      }
      if (!that.endTime) {
        that.endTime = ''
      }
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/queryForPage`, {
        page: that.page,
        limit: that.limit,
        companyId: that.$store.state.companyId,
        // currentProcessKey: 'addCustomer',
        customerManageStartTime: that.startTime,
        customerManageEndTime: that.endTime,
        keywords: that.inputValue,
        successFlag: true
      }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.pageSize
          this.total = res.data.data.total
          this.loading = false
        }
      })
    },
    judge () {
      if (new Date(this.startTime).getTime() > new Date(this.endTime).getTime()) {
        this.$message({
          message: '结束时间不能大于开始时间哟',
          type: 'warning'
        })
      }
    },
    searchBtn () {
      this.page = 1
      this.loading = true
      this.getData()
    },
    onDetail (row) {
      this.$router.push({name: 'CaseDetail', query: {id: row.id}})
    },
    jump (page) { // 分页
      this.page = page
      this.getData()
    }
  },
  watch: {
    inputValue (val) {
      if (val === '') {
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
  .app-container /deep/ .el-input__icon{
    color: #30313a;
  }
</style>



// WEBPACK FOOTER //
// src/pages/successfulCases/successfulCases.vue